import $ from 'jquery' // jQuery
if (window.matchMedia('(max-width:768px)').matches) {
  $('input[name=search]').attr('placeholder', '検索キーワードを入力')
}
